import React, { useEffect, useState, Suspense, Fragment } from "react";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { Box, Button, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useParams } from "react-router-dom";
import { formatBytes } from "assets/js/common";
import moment from "moment";
import InnerHTML from "dangerously-set-html-content";
import { palette } from "@mui/system";

const useStyles = makeStyles((theme) => ({
  detail: {
    "& .h3": {
      fontSize: rem(18),
      lineHeight: rem(24),
      fontWeight: 700,
      "& .ico-new": {
        position: "relative",
        top: "-1px",
      },
    },
    "& .board-info": {
      marginTop: rem(4),
    },
    "& .file-btn": {
      minWidth: "auto",
      fontSize: rem(14),
      fontWeight: 400,
      lineHeight: 1,
      color: theme.palette.info.main,
      textDecoration: "underline",
      textUnderlinePosition: "under",
    },
  },
}));

export default function NoticeDetail(props) {
  const dispatch = useDispatch();
  const { seq } = useParams();
  const classes = useStyles();

  const [notice, setNotice] = useState("");
  const [storeList, setStoreList] = useState([]);

  const loadData = () => {
    axios.get(`/api/cm/notice/get/${seq}`).then((res) => {
      if (res.data.data) {
        console.log("res.data.data", res.data.data);
        setNotice(res.data.data.notice);
      }
    });
  };

  const isNew = (rgstYmd) => {
    let today = moment();
    let rgst = moment(rgstYmd);
    return today.diff(rgst, "days") <= 7;
  };

  const loadStoreList = (tp) => {
    let store = "";
    axios
      .get(`/api/st/store-code`, {
        params: {
          tp: tp,
          useYn: "Y",
        },
      })
      .then((res) => {
        if (res.data.data) setStoreList(res.data.data);
      });
    return store;
  };

  const getStoreNm = (cd) => {
    console.log("dd", cd);
    let find = storeList.find((store) => store.cd == cd);
    return find ? find.nm : "전체";
  };

  useEffect(async () => {
    window.scrollTo(0, 0);
    loadData();
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "공지사항", menu: false }));
  }, [init]);

  useEffect(() => {
    if (notice) {
      loadStoreList(notice.tp);
    }
  }, [notice]);

  const downloadFiles = (item) => {
    window.location.href = `csrmegamart://external-url?${
      axios.defaults.baseURL
    }/api/st/s3/download?fileUrl=${item.fileUrl}&fileName=${item.fileName}`;
    // axios
    //   .get(`api/st/s3/download`, {
    //     params: { fileUrl: item.fileUrl, fileName: item.fileName },
    //     responseType: "arraybuffer",
    //   })
    //   .then((res) => {
    //     let blob = new Blob([res.data], {
    //       type: res.headers["content-type"],
    //     });

    //     if (window.navigator.msSaveOrOpenBlob) {
    //       // IE 10+
    //       window.navigator.msSaveOrOpenBlob(blob, item.fileName);
    //     } else {
    //       // not IE
    //       let link = document.createElement("a");
    //       link.dowload = item.fileName;
    //       link.setAttribute("download", item.fileName);
    //       link.href = window.URL.createObjectURL(blob);
    //       link.target = "_self";
    //       link.click();
    //     }

    //     // let url = window.URL.createObjectURL(blob);

    //   });

    // axios({
    //   url: "api/st/s3/download",
    //   params: { fileUrl: item.fileUrl, fileName: item.fileName },
    //   method: "GET",
    //   responseType: "blob", // important
    //   // headers: {
    //   //   "Content-Type":
    //   //     "multipart/form-data; boundary=<calculated when request is sent>",
    //   // },
    // }).then((response) => {

    //   const url = window.URL.createObjectURL(
    //     new Blob([response.data], {
    //       type: res.headers["content-type"],
    //     })
    //   );
    //   const link = document.createElement("a");

    //   link.dowload = item.fileName;
    //   link.href = url;
    //   link.setAttribute("download", item.fileName); //or any other extension
    //   document.body.appendChild(link);
    //   link.target = "_self";
    //   link.click();
    //   link.remove();
    // });
  };

  return (
    <>
      {notice && (
        <div className={classes.detail}>
          <Box className="box-type-4">
            <div className="title-group">
              <h3 className="h3">
                {notice.ttl}
                {isNew(notice.rgstYmd) && <i className="ico-new" />}
              </h3>
            </div>

            <div className="board-info">
              <span>{notice.formatRgstYmd}</span>
              <span>{getStoreNm(notice.store)}</span>
            </div>
          </Box>
          <Divider />
          <Box className="box-type-1">
            <p className="board-cont">
              <InnerHTML html={notice.cont} />
            </p>

            {notice.noticeFiles.length > 0 && (
              <div className="board-file">
                <p className="title">
                  <span>첨부파일</span>
                </p>
                <div className="names">
                  {notice.noticeFiles.map((item, i) => (
                    <Fragment key={i}>
                      <span className="name">
                        <Button
                          className="file-btn"
                          onClick={() => {
                            downloadFiles(item);
                          }}
                        >
                          {item.fileName}
                        </Button>
                        <span className="size">
                          {formatBytes(item.fileSize)}
                        </span>
                      </span>
                    </Fragment>
                  ))}
                </div>
              </div>
            )}
          </Box>
        </div>
      )}
    </>
  );
}
